<p-breadcrumb [home]="home" [model]="breadcrumb" styleClass="p-mb-2"></p-breadcrumb>

<p-overlayPanel #pagePanel appendTo="body" styleClass="business-search-panel">
  <div class="business-search-list">
    <input
      #pageSearchInput
      type="text"
      pInputText
      [(ngModel)]="pageSearch"
      placeholder="Search business pages..."
      class="full-width p-mb-2"
      (input)="filterPages()"
    >
    <div class="business-search-items">
      <div
        *ngFor="let p of filteredPages"
        class="business-search-item"
        (click)="onPageSelect(p.slug)"
      >
        <i class="pi {{ p.icon }}"></i>
        <span>{{ p.name }}</span>
      </div>
      <div *ngIf="!filteredPages.length" class="business-search-empty">
        No pages found
      </div>
    </div>
  </div>
</p-overlayPanel>

<div *ngIf="showIconGrid" class="business-icon-grid-wrapper">
  <div *ngFor="let group of categoryGroups" class="p-card business-card p-mb-2">
    <div class="p-px-3 p-pt-3 p-pb-1">
      <h3 class="p-mt-0 p-mb-2 business-category-title">
        <i class="pi {{ group.meta.icon }}"></i>
        {{ group.meta.label }}
      </h3>
    </div>
    <div class="p-px-4 p-pb-3 business-grid">
      <a
        *ngFor="let page of group.pages"
        class="business-tile"
        [routerLink]="page.routerLinkPrefix ?? ['/business', page.slug]"
      >
        <i class="pi {{ page.icon }}" style="font-size: 1.5rem" aria-hidden="true"></i>
        <span class="business-tile-name">{{ page.name }}</span>
      </a>
    </div>
  </div>
</div>

<div *ngIf="!showIconGrid" class="p-pt-2">
  <router-outlet></router-outlet>
</div>